
export const  INTERNAL = 1
export const EXTERNAL = 2
export const OTHER_ANIMATOR = 3

export const TYPES_ANIMATOR = { 
  [INTERNAL]: "ACTIVITY.TYPE_ANIMATOR.INTERNAL",
  [EXTERNAL]: "ACTIVITY.TYPE_ANIMATOR.EXTERNAL",
  [OTHER_ANIMATOR]: "ACTIVITY.TYPE_ANIMATOR.OTHER",
}

export const animatorTypeUIHelper = (intl) =>
  Object.keys(TYPES_ANIMATOR).map((key) => ({
    value: parseInt(key),
    label: intl.formatMessage({ id: TYPES_ANIMATOR[key] }),
  }))
